var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneSettings1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6668 8.66602H7.13346C6.21299 8.66602 5.4668 9.41221 5.4668 10.3327V15.666C5.4668 16.5865 6.21299 17.3327 7.13347 17.3327H15.6668C16.5873 17.3327 17.3335 16.5865 17.3335 15.666V10.3327C17.3335 9.41221 16.5873 8.66602 15.6668 8.66602ZM7.13346 7.66602C5.6607 7.66602 4.4668 8.85992 4.4668 10.3327V15.666C4.4668 17.1388 5.66071 18.3327 7.13347 18.3327H15.6668C17.1396 18.3327 18.3335 17.1388 18.3335 15.666V10.3327C18.3335 8.85992 17.1396 7.66602 15.6668 7.66602H7.13346Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10.3672C21.2761 10.3672 21.5 10.591 21.5 10.8672V15.1339C21.5 15.41 21.2761 15.6339 21 15.6339C20.7239 15.6339 20.5 15.41 20.5 15.1339V10.8672C20.5 10.591 20.7239 10.3672 21 10.3672Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSettings1);
export default __webpack_public_path__ + "static/media/phone-settings1.21ca949b327e2891b24daf39161ced85.svg";
export { ForwardRef as ReactComponent };